import styled from 'styled-components'
import { theme } from 'utils/theme'

export const TogglePlayIconWrapper = styled.div`
  height: 110px;
  width: 110px;
  border-radius: 50%;
  background: ${theme.colors.alfaLightGold};
  display: flex;
  justify-content: center;
  align-items: center;

  .icon-container {
    left: 4px;
  }
`

export const Duration = styled.div`
  color: rgba(255, 255, 255, 0.7);
  font-family: AzoSans;
  font-weight: 600;
  font-size: 14px;
`

export const TogglePlay = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transition: all 0.3s ease-in-out;
  opacity: ${props => (props.isControlsShown ? '1' : '0')};
`

export const VideoControls = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  position: absolute;
  bottom: 10px;
  padding: 10px;
  width: 100%;
  max-width: 700px;
  flex-wrap: wrap;
  background: ${theme.colors.alfaLightGold};
  box-shadow: 0 8px 32px 0 rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(4px);
  border-radius: 10px;
  opacity: ${props => (props.isControlsShown ? '1' : '0')};
`

export const VideoWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  overflow: hidden;
  border-radius: 10px;

  video {
    width: 100%;
    height: 100%;
  }
`

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;

  input[type='range'] {
    -webkit-appearance: none !important;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 20px;
    height: 4px;
    width: 420px;
  }

  input[type='range']::-webkit-slider-thumb {
    cursor: pointer;
  }

  input[type='range']::-moz-range-progress {
    background: white;
  }
`

export const VideoContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
`

export const Buffering = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`
